import { useCallback, type JSX } from 'react';
import { useBeforeUnload, useBlocker } from 'react-router';
import { Button, Dialog } from '@viniciomendesr/rayrovisk-design-system';

export function PendingEditsGuard({ when }: { when: boolean }): JSX.Element {
  const blocker = useBlocker(when);

  useBeforeUnload(
    useCallback(
      (event) => {
        if (!when) return;

        event.preventDefault();
        event.returnValue = '';
      },
      [when]
    )
  );

  const blocked = blocker.state === 'blocked';

  return (
    <Dialog
      open={blocked}
      onOpenChange={(open) => {
        if (!open && blocker.state === 'blocked') blocker.reset();
      }}
      title="Sair sem copiar?"
      description="Você ainda não copiou suas alterações. Se sair, elas serão perdidas."
      destructive
      footer={
        <>
          <Button
            variant="secondary"
            size="sm"
            onClick={() => {
              if (blocker.state === 'blocked') blocker.reset();
            }}
          >
            Continuar editando
          </Button>
          <Button
            variant="destructive"
            size="sm"
            onClick={() => {
              if (blocker.state === 'blocked') blocker.proceed();
            }}
          >
            Sair sem copiar
          </Button>
        </>
      }
    />
  );
}
